import axios from "axios";
import { toast } from "react-toastify";
import { Urls, mainUrl } from "../apiUrls/apiUrl";

export const PROJECT_ARCHIVAL = {
  getDPRDetails,
  GetResourcesManpowerDetails,
  GetResourcesMachineryDetails,
  GetResourceMaterialDetails,
  GetSOPSafetyDetails,
  GetLogObservations,
  GetLogIncidents,
  Get_JobSpecificTraining,
  Get_ConsequenceManagement,
  Get_ToolboxTraining,
  Get_WorkPermit,
  GetNCRs,
  GetStandardSOPs,
  GetJobMethodologies,
  GetSOPChecklists,
  GetRisks,
  GetIssues,
  GetPictures,
};

function handleError(error) {
  if (error.response) {
    const { status, data } = error.response;
    if (status === 401) {
      toast.error("Unauthorized Access!");
    } else if ([400, 404, 409, 500].includes(status)) {
      toast.error(data?.Message || "An error occurred.");
    }
  } else {
    toast.error("An unexpected error occurred.");
  }
  //   return Promise.reject(error);
}

function getAuthToken() {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return null;
  }
  return { token, state };
}

function getDPRDetails(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/GetDPRDetails`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function GetResourcesManpowerDetails(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(
      `${mainUrl}api/ProjectArchival/GetResourcesManpowerDetails`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => response.data)
    .catch(handleError);
}
function GetResourcesMachineryDetails(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(
      `${mainUrl}api/ProjectArchival/GetResourcesMachineryDetails`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => response.data)
    .catch(handleError);
}
function GetResourceMaterialDetails(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/GetResourceMaterialDetails`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function GetSOPSafetyDetails(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/GetSOPSafetyDetails`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function GetLogObservations(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/GetLogObservations`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function GetLogIncidents(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/GetLogIncidents`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function Get_JobSpecificTraining(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/Get_JobSpecificTraining`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function Get_ConsequenceManagement(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/Get_ConsequenceManagement`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function Get_ToolboxTraining(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/Get_ToolboxTraining`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function Get_WorkPermit(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/Get_WorkPermit`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function GetNCRs(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/GetNCRs`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function GetStandardSOPs(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/GetStandardSOPs`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function GetJobMethodologies(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/GetJobMethodologies`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function GetSOPChecklists(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/GetSOPChecklists`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function GetRisks(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/GetRisks`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function GetIssues(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/GetIssues`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function GetPictures(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/ProjectArchival/GetPictures`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
